import { useState, useEffect } from "react";
import axios from "axios";
import { GitBranch, ChevronDown, ChevronRight } from "lucide-react";

import { API } from "../lib/api";

function renderNode(node, level = 0, key = "root") {
  if (!node) return null;
  const colors = ["#2346ff", "#1d3ace", "#3b82f6", "#6366f1", "#8b5cf6"];
  const color = colors[Math.min(level, colors.length - 1)];
  const hasChildren = node.children && node.children.length > 0;

  return (
    <div key={key} className="flex flex-col items-center">
      <div
        className="px-4 py-2 rounded-xl text-center shadow-sm border-2 transition-all duration-200"
        style={{
          minWidth: "120px",
          maxWidth: "160px",
          backgroundColor: level === 0 ? color : `${color}18`,
          borderColor: color,
          color: level === 0 ? "white" : color
        }}
      >
        <p className="font-bold font-heading text-sm leading-tight">{node.name}</p>
        {node.title && node.title !== node.name && (
          <p className="text-[10px] opacity-70 mt-0.5 leading-tight">{node.title}</p>
        )}
      </div>
      {hasChildren && (
        <div className="flex flex-col items-center">
          <div className="w-px h-5 bg-slate-300" />
          <div className="flex gap-3 items-start">
            {node.children.map(function(child, idx) {
              return (
                <div key={child.id || idx} className="flex flex-col items-center">
                  <div className="w-px h-4 bg-slate-300" />
                  {renderNode(child, level + 1, child.id || String(idx))}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default function OrgChartPage() {
  const [chart, setChart] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/orgchart`, { withCredentials: true })
      .then(r => setChart(r.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-4 sm:p-6">
      <div className="flex items-center gap-2 mb-6">
        <GitBranch className="w-5 h-5 text-[#2346ff]" />
        <div>
          <h1 className="text-xl font-bold font-heading text-slate-900">Organograma</h1>
          <p className="text-sm text-slate-500">Estrutura organizacional da Schumann</p>
        </div>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-16">
          <div className="w-8 h-8 border-4 border-[#2346ff] border-t-transparent rounded-full animate-spin" />
        </div>
      ) : !chart || !chart.data ? (
        <div className="text-center py-16 text-slate-400">
          <GitBranch className="w-12 h-12 mx-auto mb-3 opacity-30" />
          <p>Organograma não configurado</p>
        </div>
      ) : (
        <div className="bento-card p-6 overflow-x-auto">
          <div className="inline-flex min-w-full justify-center pt-2 pb-4">
            {renderNode(chart.data, 0)}
          </div>
        </div>
      )}

      {chart && chart.updated_at && (
        <p className="text-xs text-slate-400 text-center mt-4">
          Atualizado em {new Date(chart.updated_at).toLocaleDateString("pt-BR")}
        </p>
      )}
    </div>
  );
}
